export const COUNTRY_DESTINATION_MAP = {
  Albania: ['Albania'],
  Andorra: ['Andorra'],
  Aruba: ['Aruba'],
  Austria: ['Crystal Ski Austria', 'Salzburg'],
  Barbados: ['Barbados'],
  Bonaire: ['Bonaire'],
  Bulgaria: ['Bourgas', 'Varna', 'Crystal Ski Bulgaria'],
  Canada: ['Crystal Ski Canada'],
  'Cape Verde': ['Boa Vista', 'Sal'],
  'Costa Rica': ['Costa Rica'],
  Croatia: ['Dubrovnik', 'Pula', 'Rijeka', 'Split', 'Zadar'],
  Curacao: ['Curacao'],
  Cyprus: ['Cyprus East', 'Cyprus West'],
  'Dominican Republic': ['Puerto Plata', 'Punta Cana'],
  Egypt: ['Hurghada', 'Luxor', 'Marsa Alam', 'Sharm El Sheik'],
  Finland: [
    'Lapland - Ivalo',
    'Lapland - Kajaani',
    'Lapland - Kittila',
    'Lapland - Kuusamo',
    'Lapland - Rovaniemi',
    'Secondments - Lapland',
    'Crystal Ski Finland',
  ],
  France: ['Crystal Ski France'],
  Greece: [
    'Araxos',
    'Athens',
    'Corfu',
    'Crete - Chania',
    'Crete - Heraklion',
    'Halkidiki',
    'Kalamata',
    'Karpathos',
    'Kefalonia',
    'Kos',
    'Lesbos',
    'Mykonos',
    'Naxos',
    'Parga & Lefkada',
    'Rhodes',
    'Samos',
    'Santorini',
    'Skiathos',
    'Thassos',
    'Zakynthos',
  ],
  Iceland: ['Iceland'],
  India: ['Goa'],
  Indonesia: ['Bali'],
  Italy: [
    'Calabria',
    'Italy - Como',
    'Italy - Garda',
    'Italy - Maggiore',
    'Naples',
    'Puglia',
    'Sardinia - Alghero',
    'Sardinia - Olbia',
    'Sicily - Catania',
    'Sicily - Palermo',
    'Venice',
    'Crystal Ski Italy',
  ],
  Jamaica: ['Jamaica'],
  Kenya: ['Kenya'],
  Macedonia: ['Macedonia'],
  Maldives: ['Maldives'],
  Malta: ['Malta'],
  Mauritius: ['Mauritius'],
  Mexico: ['Cancun'],
  Montenegro: ['Tivat'],
  Morocco: ['Agadir', 'Marrakesh'],
  Norway: ['Crystal Ski Norway'],
  Portugal: ['Algarve', 'Azores', 'Madeira'],
  Senegal: ['Senegal'],
  Seychelles: ['Seychelles'],
  Slovenia: ['Slovenia', 'Crystal Ski Slovenia'],
  Spain: [
    'Costa Almeria',
    'Costa Blanca',
    'Costa Brava',
    'Costa de la Luz',
    'Costa del Sol',
    'Costa Dorada',
    'Fuerteventura',
    'Gran Canaria',
    'Huelva',
    'Ibiza',
    'La Gomera',
    'La Palma',
    'Lanzarote',
    'Mallorca',
    'Menorca',
    'Tenerife',
    'TXC Mallorca',
    'Crystal Ski Lleida',
  ],
  'Sri Lanka': ['Sri Lanka'],
  'St Lucia': ['St Lucia'],
  Sweden: ['Crystal Ski Sweden'],
  Switzerland: ['Switzerland', 'Crystal Ski Switzerland'],
  Tanzania: ['Zanzibar'],
  Thailand: ['Bangkok', 'Koh Samui', 'Krabi', 'Phuket'],
  'The Gambia': ['The Gambia'],
  Tunisia: ['Tunisia - Djerba', 'Tunisia - Mainland'],
  Türkiye: ['Antalya', 'Bodrum', 'Dalaman', 'Izmir'],
  'United Arab Emirates': ['Dubai'],
  USA: ['Miami', 'Orlando'],
  Vietnam: ['Vietnam'],
};
